<template>
  <div class="page-container">
    <div class="main-bg">
      <div class="center-bg">
        <div class="logo-bg">
          <img src="../../assets/img/share.png" alt="" />
        </div>
        <!-- <h2>天安金交中心</h2> -->
        <div class="sub-title">您专属的财富管家</div>
        <a
          class="download"
          id="download"
          :href="androidDownloadUrl"
          @click="onDownload">
          下载天安金交中心APP
        </a>
        <!-- <a class="download" id="download"> 下载天安金交中心APP </a> -->
      </div>
      <div
        v-if="isShowTips"
        class="wxtip"
        id="JweixinTip"
        @click="isShowTips = false">
        <span class="wxtip-icon"></span>
        <p class="wxtip-txt">点击右上角<br />选择在浏览器中打开</p>
      </div>
      <!-- <div class="wxtip" id="JweixinTip">
        <span class="wxtip-icon"></span>
        <p class="wxtip-txt">点击右上角<br />选择在浏览器中打开</p>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isAndroid: false,
      isIOS: false,
      isShowTips: false,
      androidDownloadUrl:
        "https://tianbaolian.oss-cn-shanghai-finance-1-pub.aliyuncs.com/dev/ioClound-app-release.apk",
      iOSDownloadUrl:
        "https://apps.apple.com/cn/app/%E5%A4%A9%E5%AE%89%E9%87%91%E4%BA%A4%E4%B8%AD%E5%BF%83/id1127135075"
    }
  },
  mounted() {
    this.checkPhone()
    // let btn1 = document.getElementById("download")
    // btn1.href = this.iOSDownloadUrl
    // this.weixinTip(btn1)
  },
  methods: {
    /* 判断用户手机为安卓还是iphone */
    checkPhone() {
      let self = this
      let agent = navigator.userAgent || navigator.vendor || window.opera
      if (agent != null) {
        let agentName = agent.toLowerCase()
        if (/android/i.test(agentName)) {
          self.isAndroid = true
        } else if (/iphone/i.test(agentName)) {
          self.isIOS = true
        }
      }
    },

    onDownload() {
      let aLabel = document.getElementById("download")
      if (this.isAndroid) {
        //安卓手机
        aLabel.href = this.androidDownloadUrl
      } else if (this.isIOS) {
        //苹果手机
        aLabel.href = this.iOSDownloadUrl
      }
      if (this.isWechant() && this.isAndroid) {
        this.isShowTips = true
      }
    },
    weixinTip(ele) {
      let ua = navigator.userAgent
      let isWeixin = !!/MicroMessenger/i.test(ua)
      if (isWeixin) {
        ele.onclick = function (e) {
          window.event ? (window.event.returnValue = false) : e.preventDefault()
          document.getElementById("JweixinTip").style.display = "block"
        }
        document.getElementById("JweixinTip").onclick = function () {
          this.style.display = "none"
        }
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page-container {
  background-color: white;
  padding: 0;
}
.main-bg {
  width: 100%;
  height: 100vh;
  // background-image: url("../../assets/img/register/register_bg.png");
  // background-repeat: no-repeat;
  // background-size: 100% 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  .center-bg {
    margin-top: 45%;
    display: flex;
    flex-direction: column;
    align-items: center;
    h2 {
      margin-top: -0px;
      margin-bottom: -0px;
    }
    .sub-title {
      margin-top: 10px;
      color: gray;
      font-size: 18px;
      letter-spacing: 5px;
    }
    .download {
      margin-top: 50px;
      background-color: rgb(246, 153, 19);
      padding: 10px 20px;
      border-radius: 6px;
      color: white;
      font-size: 16px;
    }
    .download:hover {
      opacity: 0.8;
    }
  }
}

/*核心css*/
.wxtip {
  background: rgba(0, 0, 0, 0.8);
  text-align: center;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 998;
  // display: none;
}

.wxtip-icon {
  width: 52px;
  height: 67px;
  background: url(http://caibaojian.com/d/uploads/2016/01/weixin-tip.png)
    no-repeat;
  display: block;
  position: absolute;
  right: 30px;
  top: 20px;
}

.wxtip-txt {
  padding-top: 107px;
  color: #fff;
  font-size: 16px;
  line-height: 1.5;
}
</style>